import React from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

export const CaseClosedSummary = ({ caseData, caseId, closeReasons, onReloaded }) => {
  const c = caseData;
  const isNotAdmitted = c.closure.outcome === "nao_internacao";
  const reason = closeReasons.find((r) => r.id === c.closure.reason);
  const canReopen = isNotAdmitted && reason?.reopenable !== false;

  const reopen = async () => {
    if (!window.confirm("Reabrir este caso? Ele voltará à fila de atendimento.")) return;
    try {
      await api.post(`/cases/${caseId}/reopen`);
      toast.success("Caso reaberto");
      onReloaded();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao reabrir");
    }
  };

  return (
    <section className={`border rounded-xl p-6 ${isNotAdmitted ? "bg-orange-50 border-orange-200" : "bg-green-50 border-green-200"}`}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className={`flex items-center gap-2 font-semibold ${isNotAdmitted ? "text-orange-700" : "text-green-700"}`}>
          <CheckCircle2 className="w-5 h-5" /> {isNotAdmitted ? "Caso encerrado sem internação" : "Caso concluído com internação"}
        </div>
        {canReopen && (
          <button data-testid="reopen-btn" onClick={reopen}
            className="px-3 py-1.5 border border-[#0B2B62] text-[#0B2B62] rounded-md text-sm font-semibold hover:bg-[#0B2B62] hover:text-white transition-colors">
            Reabrir caso
          </button>
        )}
      </div>
      <div className="mt-3 grid md:grid-cols-2 gap-3 text-sm text-slate-700">
        {isNotAdmitted ? (
          <>
            <div className="md:col-span-2"><span className="text-slate-500">Motivo: </span><b>{c.closure.reason_label}</b></div>
            {c.closure.reason_details && <div className="md:col-span-2"><span className="text-slate-500">Observações: </span>{c.closure.reason_details}</div>}
            <div className="md:col-span-2 text-xs text-slate-500">Encerrado por {c.closure.closed_by} em {new Date(c.closure.closed_at).toLocaleString("pt-BR")}</div>
          </>
        ) : (
          <>
            <div><span className="text-slate-500">Clínica: </span>{c.closure.clinic_name}</div>
            <div><span className="text-slate-500">Admissão: </span>{new Date(c.closure.admission_datetime).toLocaleString("pt-BR")}</div>
            <div><span className="text-slate-500">Modalidade: </span>{c.closure.modality}</div>
            <div><span className="text-slate-500">Responsável: </span>{c.closure.responsible}</div>
          </>
        )}
      </div>
    </section>
  );
};
